import axios from "axios";
const CUDYBLOGSURL = "https://blog.cudy.co/wp-json/wp/v2/posts";

export const getBlogs = async (pageNumber) => {
    try {
        const { data, headers } = await axios.get(`${CUDYBLOGSURL}?orderby=date&status=publish&page=${pageNumber}`);
        return { data, total: headers['x-wp-total'] };
        // eslint-disable-next-line no-empty
    } catch (err) {

    }
}

export const getBlogData = async (id) => {
    // eslint-disable-next-line no-useless-catch
    try {
        const { data: { _links: links, ...blogData } } = await axios.get(`${CUDYBLOGSURL}/${id}`);
        const mediaDataLink = links["wp:featuredmedia"][0].href;
        const { data: mediaData } = await axios.get(mediaDataLink);
        const postData = {
            ...blogData,
            mediaData
        }

        return postData;
    } catch (err) {
        throw err;
    }
}


export const getPreviewText = (text) => {
    if (text.startsWith(`{"time":`)) {
        const articleBodyParas = JSON.parse(text).blocks.filter(item => item.type === "paragraph");
        let previewText = "";
        if (articleBodyParas.length > 0) {
            previewText = articleBodyParas[0].data.text
        }

        return previewText;
    } else {
        return text;
    }
}